module.exports = __webpack_public_path__ + "img/w.7a4d6b57.png";